import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { SkillsetRollupDemoService } from '../../design/demo-services/skillsetRollup-demo.service';


@Injectable({
  providedIn: 'root'
})
export class CallBoardsDashboardService {

  
  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private demoService: SkillsetRollupDemoService) { }

  getCallBoardData(view: string, boardLocation: string): Observable<any> {

    var url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/callboard/boardData?view=${view}&location=${boardLocation}`;

    const loader = this.route.params.pipe(
      switchMap(bl => 
        (environment.demo ? this.demoService.get(boardLocation) : this.http.get(url))
        .pipe(
          map((b: any) => b),
          catchError(error => of({
            isLoading: false, 
            isLoaded: false,
            isError: true,
            errorMessage: error.error instanceof ErrorEvent ? `an error occurred: ${error.error.message}` : `backend error: ${error.status} - ${error.message}`,
            boardLocation: bl,
            data: {}
          }))
        )
      ),
      map((d: any) => {

        var boardStatusFunc = (): number => {
          if (environment.demo)
            return 0;
          var startTime = new Date(d.LastUpdated);
          var endTime = new Date();
          var difference = endTime.getTime() - startTime.getTime(); 
          return Math.round(difference / 60000);
        };

        //var getScrollingMessage = (): string => {
         // var scrollingMessage = "";

         // d.Items.forEach(s => {
          //  if (s["WarningLevel"] === 2) {
          //    if (scrollingMessage.length === 0) {
          //      scrollingMessage = "!!! Please pickup phone there";
          //    }
          //    scrollingMessage += " " + s["CallsWaiting"] + " Calls Waiting for " + s["MaxWaitTime"] + " on " + s["Name"] + " Queue !!!";
          //  }
          //});
          //return scrollingMessage;
        //};

        const ret = d.isError === true ? d : {

          boardLocation: d.Location,
          boardName: d.Name,
          LastUpdated: environment.demo ? new Date().toLocaleString() : d.LastUpdated,

          skillsets: [] = d.Items,

          minutesFromLastUpdate: boardStatusFunc(),
          playAlert: d.IsAlert,
          //scrollingMessage: getScrollingMessage(),

          isFound: d.Items.length === 0,

          isLoading: false,
          isLoaded: true,
          isError: false,
          errorMessage: ''
        };
        return ret;
      })
    );

    return loader;
  }
}
